<!--
 * @Author: 罗
 * @Date: 2025-05-12 10:08:12
 * @LastEditors: 罗
 * @LastEditTime: 2025-05-21 16:54:47
 * @FilePath: \repair_picture_en\src\components\footer.vue
 * @Description:
 *
 * Copyright (c) 2025 by ${git_name_email}, All Rights Reserved.
-->
<template>
  <div>
    <div class="message">
      <!-- <div class="item">
        <h3>公司名称</h3>
        <p>莱斯时代（北京）科技有限公司</p>
      </div> -->
      <div class="item">
        <h3>Company Name</h3>
        <p>Jinyongmiao Technology (Langfang) Co., Ltd.</p>
      </div>
      <div class="item">
        <h3>Company address</h3>
        <p>Unit 1607, Building 0036-01, Wenchuang Park, Konggang No.1 Block, Intersection of Gongxing West Street and Yingbin Avenue, Gu'an County, Langfang City, Hebei Province, China</p>
      </div>
      <div class="item">
        <h3>Mail</h3>
        <p>mailto:ws@letshealth.cn</p>
      </div>
      <!-- <div class="item">
        <h3>商务合作</h3>
        <p>17710545460</p>
      </div> -->
      <!-- <div class="item">
        <h3>客服QQ</h3>
        <p>2118789460</p>
      </div> -->
      <!-- <div class="item">
        <div class="privacy" @click="goPrivacy">隐私政策</div>
      </div> -->
    </div>
    <!-- <div class="banquan">
      <span style="cursor: pointer" @click="jumpOther"
        >© 莱斯时代（北京）科技有限公司 | 京ICP备2022035200号-5A</span
      >
    </div> -->
  </div>
</template>

<script>
  export default {
    name:"footers",
    methods: {
      jumpOther() {
        window.open("https://beian.miit.gov.cn/#/Integrated/index");
      },
    },
  };
</script>

<style  scoped lang="less">
  .message {
      // margin-top: 114px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(37, 42, 52, 1);
      height: 140px;
      .item {
        text-align: center;
        margin-right: 100px;
        .privacy {
          color: #ffffff;
          font-size: 20px;
          text-decoration: underline;
          cursor: pointer;
        }
        &:last-child {
          margin-right: 0;
        }
        h3 {
          font-size: 24px;
          color: #fff;
          font-weight: 500;
        }
        p {
          font-size: 18px;
          color: #fff;
          margin-top: 17px;
        }
      }
    }
    .banquan {
      width: 100%;
      min-width: 1200px;
      height: 80px;
      color: #fff;
      line-height: 80px;
      // font-size: 24px;
      background: rgba(37, 42, 52, 1);
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue